export default function() {
    return this._graphvizVersion;
};
